module.exports = __webpack_public_path__ + "assets/img/Bus.5916cf9d.jpg";